import { Component, ChangeDetectionStrategy, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

/**
 * Netpay devuelve la URL de éxito con el trackingId en el primer segmento de ruta
 * (`/callback/netpay/paymentlink/success/:sessionId/:uuid`). Este componente
 * reenvía a `/callback/paymentlink/success?trackingId=...` que es lo que consume
 * {@link PaymentLinkSuccessComponent}.
 */
@Component({
  selector: 'app-netpay-payment-link-success-redirect',
  standalone: true,
  imports: [CommonModule],
  template: `
    <p class="min-h-screen flex items-center justify-center px-4 text-center text-slate-500 text-sm">
      Redirigiendo…
    </p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NetpayPaymentLinkSuccessRedirectComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit(): void {
    const trackingId = this.route.snapshot.paramMap.get('sessionId') ?? '';
    void this.router.navigate(['/callback/paymentlink/success'], {
      queryParams: { trackingId },
      replaceUrl: true
    });
  }
}
